import React, { createContext, useContext, useState } from 'react';

const CalculatorContext = createContext();

export const useCalculator = () => {
  const context = useContext(CalculatorContext);
  if (!context) {
    throw new Error('useLoading must be used within a CalculatorProvider');
  }
  return context;
};

export const CalculatorProvider = ({ children }) => {

    function Add(...numbers) {
        if (Array.isArray(numbers[0])) {
            let sumOfArray = numbers[0].reduce((acc, currentValue) => acc + currentValue, 0);
            return sumOfArray;
        } else {
            return numbers.reduce((total, num) => total + num, 0);
        }
    }    

    function Percentage(Part, Whole) {
        const percentageValue = (Part / Whole) * 100;
        return (percentageValue);
    }

  return (
    <CalculatorContext.Provider value={{ Add , Percentage }}>
      {children}
    </CalculatorContext.Provider>
  );
};